<app-card
  title="Order Complete!"
  data-qa-id="Order Complete Instructions"
  headerClasses="p-6 is-size-3 is-size-4-mobile has-text-weight-bold card-header-title has-text-white has-background-green"
  [contentClasses]="'card-body-background p-6 ' + cardContentClass"
>
  <p class="mb-4">
    Your order has been placed
    @if (inHomeBookingResult) {
      <span>!</span>
    } @else {
      {{
        !orderCompleteDetails || isFree || isPayLater
          ? '.'
          : ' and your card has been charged. The charge will appear on your statement as "ANALYTE HEALTH".'
      }}
    }
  </p>

  @if (!inHomeBookingResult) {
    <div>
      <p class="mb-4">
        <strong>Please Note:</strong>
        @if (hasEmail || sendSms) {
          Within 15 minutes, you should receive a message in your online account with your testing instructions. To
          access your
          <a [href]="myAccountUrl">online account</a>, please log in with your
          {{ hasEmail ? 'email address' : 'phone number' }}.
        } @else {
          @if (orderCompleteDetails) {
            Since you chose not to be contacted via text message or email, you will need to text our Patient Services
            Team at 1-800-456-2323 to have your lab form faxed directly to the lab you chose at checkout, as well as to
            receive your results. They can provide you with account access if you wish to log in to a secure online
            account to view your order and results.
          } @else {
            If you chose to be contacted, within 15 minutes you should receive a message in your online account with
            your testing instructions. Sign in to your
            <a [href]="myAccountUrl">online account</a> with your email or phone number. Otherwise, you will need to
            text our Patient Services Team at 1-800-456-2323 to have your lab form faxed directly to the lab you
            selected at checkout, as well as to receive your results. They can provide you with account access if you
            wish to log in to a secure online account to view your order and results.
          }
        }
      </p>
      <p class="mb-4">
        Inside your account, you will also be able to access your test order form. From your phone, computer, or other
        device, you can either print it or electronically fax it directly to the lab.
        <strong>No appointment is required</strong> for you to visit the lab, so you can walk in any time within the
        lab's business hours.
      </p>
      <p class="mb-4">{{ assistanceDetails }}</p>
    </div>
  } @else {
    <p class="mb-4">
      Your In-Home Collection has been scheduled for {{ inHomeBookingResult.date | date: 'MM/dd/yyyy' }} between
      {{ inHomeBookingResult.bookingSlot.period }}.
    </p>
    <p class="mb-4">
      Your specialist will arrive promptly at {{ inHomeBookingResult.address.street }},
      {{ inHomeBookingResult.address.city }}, {{ inHomeBookingResult.address.state }}
      {{ inHomeBookingResult.address.zipCode }} and will already have your paperwork ready.
    </p>
    <p class="mb-4">
      All we ask is before they arrive, please secure any pets you may have so they do not interfere with your
      appointment.
    </p>
    <p class="mb-4">{{ assistanceDetails }}</p>
  }

  <p data-qa-id="Cancellation Policy Section">
    <strong>Our Cancellation Policy:</strong> You may cancel your order any time before your
    {{ inHomeBookingResult ? 'In-Home Collection appointment' : 'specimen collection' }}.
    @if (orderCompleteDetails && !isFree && !isPayLater && !inHomeBookingResult) {
      <span>
        Refunds will be issued within 24-48 hours of cancellation
        <strong>minus a 20% cancellation fee</strong>.
      </span>
    }
    All cancellation requests after 21 days of purchase will be given credit for future testing.
  </p>
</app-card>
